<h2 class="dialog-heading">{{ title }}</h2>

<mat-form-field appearance="fill" class="full-width">
    <input matInput [(ngModel)]="name" cdkFocusInitial (keyup.enter)="save()" placeholder="Enter Project Name" />
</mat-form-field>

<!-- error message -->
<div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
</div>

<div class="actions">
    <button mat-button class="cancel-btn" mat-dialog-close>
    Cancel
  </button>

    <button mat-raised-button class="save-btn" [disabled]="!name.trim()" (click)="save()">
    {{ confirmLabel }}
  </button>
</div>